var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Token"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.0227 64C30.3042 64 28.6001 63.5398 27.0902 62.677L8.8702 52.1577C8.76235 52.1002 8.65449 52.0283 8.54664 51.9636L8.39565 51.8701C5.58428 50.0151 3.92334 46.9376 3.92334 43.6158V20.3914C3.92334 16.8754 5.81436 13.6039 8.84863 11.8566L27.083 1.33019C28.5714 0.460173 30.2826 0 32.0227 0H32.1017C33.813 0.0143804 35.4883 0.467363 36.9551 1.33019L55.1895 11.8566C58.2309 13.6039 60.1148 16.8754 60.1148 20.3914V43.6086C60.1148 47.1246 58.2238 50.3961 55.1895 52.1433L36.9479 62.677C35.4452 63.547 33.7411 64 32.0227 64ZM32.0227 4.31412C31.0448 4.31412 30.0885 4.57297 29.2544 5.0619L11.0057 15.5956C9.29442 16.5806 8.23746 18.4141 8.23746 20.3914V43.6086C8.23746 45.478 9.17219 47.2109 10.7325 48.2391C10.7325 48.2391 10.941 48.3685 10.9985 48.3973L29.2544 58.9381C30.1029 59.427 31.0664 59.6859 32.0298 59.6859C32.9933 59.6859 33.9496 59.427 34.7981 58.9381L53.0396 48.4044C54.7509 47.4194 55.8078 45.5859 55.8078 43.6086V20.3914C55.8078 18.4141 54.7509 16.5806 53.0396 15.5956L34.7981 5.0619C33.9712 4.58016 33.0365 4.32131 32.0802 4.31412L32.0298 3.23559V4.31412H32.0227Z",
    fill: "#44484E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16L32 2L57.5 16V47.5L33 62L8 49.5L6 40.5L8 16ZM43.1931 30.1586L37.6926 27.1531C37.3403 26.9589 37.0527 26.6713 36.8586 26.319L33.853 20.8185C33.0621 19.3661 30.977 19.3661 30.186 20.8185L27.1805 26.319C26.9864 26.6713 26.6988 26.9589 26.3465 27.1531L20.846 30.1586C19.3935 30.9495 19.3935 33.0346 20.846 33.8256L26.3465 36.8311C26.6988 37.0252 26.9864 37.3128 27.1805 37.6651L30.186 43.1656C30.977 44.6181 33.0621 44.6181 33.853 43.1656L36.8586 37.6651C37.0527 37.3128 37.3403 37.0252 37.6926 36.8311L43.1931 33.8256C44.6455 33.0346 44.6455 30.9495 43.1931 30.1586Z",
    fill: "#44484E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/Token.47e7e662a3131eb9519e503c968d562e.svg";
export { ForwardRef as ReactComponent };